import React, { useEffect, useState } from 'react'


import { deleteCountry, deleteUser, loadCountries, loadCountriesWithCount } from '../utils/Network'
import { Link } from 'react-router-dom';
import { getDefaultName, isAdmin, sortByKey } from '../utils';
export default function CountriesContent({ page }) {

    if (!page)
        page = 1;

    const [loading, setLoading] = useState(0);
    const [pageloading, setPageLoading] = useState(false);
    const [show_delete, setShowDelete] = useState(false);

    const [countries, setCountries] = useState(null);
    const [countries2, setCountries2] = useState(null);
    const [countries3, setCountries3] = useState(null);
    const [next, setNext] = useState(null);
    const [previous, setPrevious] = useState(null);
    const [pages, setPages] = useState(null);

    useEffect(() => {
        setPageLoading(true)
        loadCountries(1, 100000).then(countries => {
            console.log(countries)
            sortByKey(countries)
            
            setCountries(countries);
            setPageLoading(false)
        });
    }, []);

    // const countryPaging = data => {
    //     var page_count = parseInt(data.count / 10) + 1;
    //     var pages_array = null;
    //     if (page_count)
    //         pages_array = range(1, page_count);
    //     setPages(pages_array);
    //     setNext(data.next);
    //     setPrevious(data.previous);

    //     if (data.results)
    //         setCountries(data.results);
    // }

    function range(start, end) {
        return Array.apply(0, Array(end))
            .map((element, index) => index + start);
    }

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteCountry(id).then(() => {
            loadCountries(1, 100000).then(countries => {
                sortByKey(countries)
                setCountries(countries);
            });
        })
    }

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                    <h3 class="box-title mt-5">
                    </h3>

                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li className="active">Countries</li>
                    </ol>
                </section>
                <section className="content padding-top-sm-0">

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="box box-primary">
                                    {pageloading && 
                                    <div class="overlay">
                                        <i class="fa fa-refresh fa-spin"></i>
                                    </div>
                                    }
                                    <div class="box-header with-border">
                                        <h3 class="box-title mt-5">Countries <small>({countries && countries.length}) items</small></h3>
                                        {isAdmin() && <>
                                        <a href="country" title="Add New" className="btn btn-orange pull-right "><i className="fa fa-plus"></i></a>
                                        <a href="#" title="Show Delete" onClick={showDelete} className="btn btn-danger pull-right margin-r-5 "><i className="fa fa-trash"></i></a>
                                        </> }
                                    </div>
                                    <div className="box-body no-padding">
                                        
                                        
                                        {countries && countries.map((item) => (
                                            <div key={item.id} className="col-md-4 height-50 padding-10 border-bottom-gray">
                                                <tr  className={loading === item.id ? "loading" : ""}>
                                                    <td style={{ width: "85px" }}>
                                                        <div className="btn-group">
                                                            {show_delete &&
                                                            <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                            }
                                                            <a href={`country/${item.id}`} className="btn btn-default btn-sm">
                                                                <i className="fa fa-check"></i>
                                                            </a>

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <a href={`country/${item.id}`}> {getDefaultName(item.names)}</a>
                                                    </td>

                                                </tr>
                                            </div>

                                        ))}

                                    </div>

                                </div>
                            </div>


                        </div>
                        <ul className="pagination cms-pagination m-0 float-right">
                            <li className="page-item"><Link className="page-link" to="#">«</Link></li>
                            {pages && pages.map((page_number) => (
                                <li key={page_number} className="page-item">
                                    <a className={page_number == page ? "page-link active" : "page-link"} href={`countries/${page_number}`}>{page_number}</a>
                                </li>
                            ))}
                            <li className="page-item"><Link className="page-link" to="">»</Link></li>
                        </ul>
                    </div>
                </section>

            </div>
        </>



    )
}
